import React from 'react';
import {useSelector} from 'react-redux';

import {DamageIcon, TroubleshootDeviceRestrictedIcon} from '@/components/Icons';
import appConfig from '@/config/appConfig.typed';
import {AD_DAMAGE_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {selectDeviceType} from '@/state/selectors/device';

import AdvancedDiagnosticCarouselPage from '../components/AdvancedDiagnosticCarouselPage';
import AdvancedDiagnosticDamageButton from './AdvancedDiagnosticDamageButton';
import AdvancedDiagnosticDamageSlides from './AdvancedDiagnosticDamageSlides';

const AdvancedDiagnosticDamage = () => {
    const deviceType = useSelector(selectDeviceType);

    const diagnosticData = appConfig.getAdConfig(deviceType, 'step1');
    const isRestrictedMarket = appConfig.getIsRestrictedMarket();

    const handleAfterChange = (newIndex) => {
        const {amplitudeQuestionnairePage} = diagnosticData[newIndex];

        amplitudeADTracking.trackADQuestionnaireScroll();
        googleAnalyticsService.trackAdQuestionnaireScroll(amplitudeQuestionnairePage);
    };

    return (
        <AdvancedDiagnosticCarouselPage
            slides={() =>
                // check comments inside AdvancedDiagnosticCarouselPage why it is rendered as a function
                AdvancedDiagnosticDamageSlides({carouselData: diagnosticData})
            }
            headerTitleKey={AD_DAMAGE_HEADER_TITLE}
            icon={isRestrictedMarket ? <TroubleshootDeviceRestrictedIcon className='h-16 w-16' /> : <DamageIcon />}
            titleItemName='damagetitle'
            descriptionItemName='damagedesc'
            onAfterChange={handleAfterChange}
        >
            <div className='mt-0 px-6 pt-0 ml:px-0'>
                <AdvancedDiagnosticDamageButton className='mt-8 ml:w-full ml:max-w-[360px]' deviceType={deviceType} />
            </div>
        </AdvancedDiagnosticCarouselPage>
    );
};

export default AdvancedDiagnosticDamage;
